// http://router.vuejs.org/en/advanced/lazy-loading.html
const Start = r => require.ensure([], () => r(require('./components/scenes/Start.vue')), 'scene')
const SceneIntro = r => require.ensure([], () => r(require('./components/scenes/SceneIntro.vue')), 'scene')
const SceneSchoolGrounds = r => require.ensure([], () => r(require('./components/scenes/SceneSchoolGrounds.vue')), 'scene')
const SceneClassroom = r => require.ensure([], () => r(require('./components/scenes/SceneClassroom.vue')), 'scene')
const SceneCanteen = r => require.ensure([], () => r(require('./components/scenes/SceneCanteen.vue')), 'scene')
const SceneCorridor = r => require.ensure([], () => r(require('./components/scenes/SceneCorridor.vue')), 'scene')
const SceneBathroom = r => require.ensure([], () => r(require('./components/scenes/SceneBathroom.vue')), 'scene')
const Conclusion = r => require.ensure([], () => r(require('./components/scenes/Conclusion.vue')), 'scene')

export default [
  {
    scene: 0,
    path: '/start',
    name: 'start',
    type: 'page',
    component: Start
  },
  {
    scene: 1,
    path: '/1/intro',
    name: 'intro',
    type: 'scene',
    component: SceneIntro
  },
  {
    scene: 2,
    path: '/2/school-grounds',
    name: 'school-grounds',
    type: 'scene',
    component: SceneSchoolGrounds
  },
  {
    scene: 3,
    path: '/3/classroom',
    name: 'classroom',
    type: 'scene',
    component: SceneClassroom
  },
  {
    scene: 4,
    path: '/4/canteen',
    name: 'canteen',
    type: 'scene',
    component: SceneCanteen
  },
  {
    scene: 5,
    path: '/5/corridor',
    name: 'corridor',
    type: 'scene',
    component: SceneCorridor
  },
  {
    scene: 6,
    path: '/6/bathroom',
    name: 'bathroom',
    type: 'scene',
    component: SceneBathroom
  },

  {
    scene: 0,
    path: '/conclusion',
    name: 'conclusion',
    type: 'page',
    component: Conclusion
  },
  // catch all redirect
  {
    scene: 0,
    path: '*',
    type: 'catchall',
    redirect: {
      path: '/start'
    }
  }
]



// WEBPACK FOOTER //
// ./src/routes.js